var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.42 22.922C33.599 22.843 33.7509 22.7133 33.8569 22.5488C33.9629 22.3843 34.0183 22.1924 34.0163 21.9967C34.0143 21.8011 33.9549 21.6103 33.8455 21.4481C33.7362 21.2858 33.5816 21.1592 33.401 21.084L24.83 17.18C24.5694 17.0611 24.2864 16.9996 24 16.9996C23.7136 16.9996 23.4306 17.0611 23.17 17.18L14.6 21.08C14.422 21.158 14.2705 21.2861 14.1642 21.4488C14.0578 21.6115 14.0012 21.8016 14.0012 21.996C14.0012 22.1903 14.0578 22.3805 14.1642 22.5432C14.2705 22.7059 14.422 22.834 14.6 22.912L23.17 26.82C23.4306 26.9388 23.7136 27.0003 24 27.0003C24.2864 27.0003 24.5694 26.9388 24.83 26.82L33.42 22.922Z",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 22V28",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24.5V28C18 28.7956 18.6321 29.5587 19.7574 30.1213C20.8826 30.6839 22.4087 31 24 31C25.5913 31 27.1174 30.6839 28.2426 30.1213C29.3679 29.5587 30 28.7956 30 28V24.5",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/Education.ad1c4863b3041df9bfbdf671fc78d596.svg";
export { ForwardRef as ReactComponent };